import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { isMobile } from 'react-device-detect';
import logo from '~/assets/logo_deitada.png';
import axios from 'axios';

import './style.scss';

import {
  Container,
  Loader,
  Info,
  SelectContainer,
  DetailsContainer,
} from './styles';
import api from '~/services/apiBearer';
import Table from '~/components/Table';


function Statement(props) {
  const property = useSelector(state => state.property.property);
  const [loader, setLoader] = useState(true);
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [statement, setStatement] = useState({});

  const [despesaBancaria, setDespesaBancaria] = useState(0);
  const [saldoAnterior, setSaldoAnterior] = useState(0);
  const [total, setTotal] = useState(0);
  const [propertyItensSegmented, setPropertyItensSegmented] = useState([]);
  const [depositData, setDepositData] = useState([]);
  const [totalCredit, setTotalCredit] = useState(0);

  const [financialResume, setFinancialResume] = useState([]);
  const financialResumeColumns = [
    { Header: 'DATA', columns: [{ accessor: 'date' }] },
    { Header: 'SITUAÇÃO', columns: [{ accessor: 'situation' }] },
    { Header: 'DESCRIÇÃO', columns: [{ accessor: 'description' }] },
    { Header: 'DÉBITO', columns: [{ accessor: 'debit' }] },
    { Header: 'CRÉDITO', columns: [{ accessor: 'credit' }] },
    { Header: 'TOTAL', columns: [{ accessor: 'total' }] },
  ];
  const financialResumeData = [
    financialResume.map(el => ({
      date: el.data,
      situation: el.situacao,
      description: el.descricao,
      debit: `R$ ${el.debito}`,
      credit: `R$ ${el.credito}`,
      total: `R$ ${el.total}`,
    })),
  ];
  if (financialResume.length) {
    financialResumeData[0].push({
      description: 'SUBTOTAL: ',
      debit: `R$ ${(
        financialResume.map(i => i.debito).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
      credit: `R$ ${(
        financialResume.map(i => i.credito).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
      total: `R$ ${(
        financialResume.map(i => i.total).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
    });
  }

  const [anotherStatements, setAnotherStatements] = useState([]);
  const statementsColumns = [
    { Header: 'DATA', columns: [{ accessor: 'date' }] },
    { Header: 'DESCRIÇÃO', columns: [{ accessor: 'description' }] },
    { Header: 'DÉBITO', columns: [{ accessor: 'debit' }] },
    { Header: 'CRÉDITO', columns: [{ accessor: 'credit' }] },
    { Header: 'TOTAL', columns: [{ accessor: 'total' }] },
  ];
  const anotherStatementData = [
    anotherStatements.map(el => ({
      date: el.data,
      description: el.descricao,
      debit: `R$ ${el.debito}`,
      credit: `R$ ${el.credito}`,
      total: `R$ ${el.total}`,
    })),
  ];
  if (anotherStatements.length) {
    anotherStatementData[0].push({
      description: 'SUBTOTAL: ',
      debit: `R$ ${(
        anotherStatements.map(i => i.debito).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
      credit: `R$ ${(
        anotherStatements.map(i => i.credito).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
      total: `R$ ${(
        anotherStatements.map(i => i.total).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
    });
  }

  const [statementBalance, setStatementBalance] = useState([]);
  const statementBalanceData = [
    statementBalance.map(el => ({
      date: el.data,
      description: el.descricao,
      debit: `R$ ${el.debito}`,
      credit: `R$ ${el.credito}`,
      total: `R$ ${el.total}`,
    })),
  ];
  if (statementBalance.length) {
    statementBalanceData[0].push({
      description: 'SUBTOTAL: ',
      debit: `R$ ${(
        statementBalance.map(i => i.debito).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
      credit: `R$ ${(
        statementBalance.map(i => i.credito).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
      total: `R$ ${(
        statementBalance.map(i => i.total).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
    });
  }

  const repassColumns = [
    { Header: 'FAVORECIDO', columns: [{ accessor: 'favorecido' }] },
    { Header: 'FORMA DE PAGAMENTO', columns: [{ accessor: 'formaPagamento' }] },
    { Header: '% DE REPASSE', columns: [{ accessor: 'percentual' }] },
    { Header: 'BANCO/AG/CONTA', columns: [{ accessor: 'banco' }] },
    { Header: 'DATA', columns: [{ accessor: 'data' }] },
    { Header: 'VALOR', columns: [{ accessor: 'valor' }] },
  ];

  const propertyInfoColumns = [
    { Header: 'ENDEREÇO', columns: [{ accessor: 'endereco' }] },
    { Header: 'INQUILINO', columns: [{ accessor: 'inquilino' }] },
    { Header: 'CONTRATO', columns: [{ accessor: 'contrato' }] }
  ];

  const [propertyStatements, setPropertyStatements] = useState([]);

  const propertyStatementsData = []
  const propertyInfoData = []
  var infoItemObj = {}

  var loop = -1
  if (propertyStatements.length > 0) {
    propertyStatements.forEach((el, idx) => {
      if ([51, 52, 53].indexOf(el.idTipo) == -1) {
        if (typeof propertyStatementsData[loop] == "undefined") {
          propertyStatementsData[loop] = []
        }
        propertyStatementsData[loop].push({
          date: el.data,
          description: el.descricao,
          debit: el.debito ? `R$ ${el.debito}` : '',
          credit: el.credito ? `R$ ${el.credito}` : '',
          total: el.total ? `R$ ${el.total}` : '',
        })
      } else {
        if (el.idTipo == 51) {
          infoItemObj['endereco'] = el.descricao
        }
        if (el.idTipo == 52) {
          infoItemObj['inquilino'] = el.descricao
        }
        if (el.idTipo == 53) {
          infoItemObj['contrato'] = el.data
        }
      }

      if (typeof infoItemObj['endereco'] != "undefined" && typeof infoItemObj['inquilino'] != "undefined" && typeof infoItemObj['contrato'] != "undefined") {
        loop++
        if (typeof propertyInfoData[loop] == "undefined") {
          propertyInfoData[loop] = []
        }
        propertyInfoData[loop].push(infoItemObj)
        infoItemObj = {}
      }
    })
  }

  if (propertyStatements.length && propertyStatementsData.length) {
    propertyStatementsData[propertyStatementsData.length - 1].push({
      description: 'SUBTOTAL: ',
      debit: `R$ ${(
        propertyStatements.map(i => i.debito).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
      credit: `R$ ${(
        propertyStatements.map(i => i.credito).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
      total: `R$ ${(
        propertyStatements.map(i => i.total).reduce((prev, next) => prev + next) || 0
      ).toFixed(2)}`,
    });
  }

  function formatDate(input) {
    const date = new Date(input);
    if (isNaN(date)) {
      return "Data inválida";
    }
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }

  function number_format(number, decimals, decPoint, thousandsSep) {
    return (number).toLocaleString('pt-BR')
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      if (('' + n).indexOf('e') === -1) {
        return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
      } else {
        var arr = ('' + n).split('e')
        var sig = ''
        if (+arr[1] + prec > 0) {
          sig = '+'
        }
        return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
      }
    }
    s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }

  useEffect(() => {
    function GetStatementDates() {
      if (!property || property.businessId === 0) return;

      api
        .get(`api/v1/WSExtratoData?Negocio=${property.businessId}`)
        .then(
          response => {
            const {
              sucesso: success,
              mensagem: message,
              conteudo: sDates,
            } = response.data;

            if (success) {
              setDates(
                sDates.map(d => {
                  const formatedDate = formatDate(
                    d.vencimentoData.substring(0, 10)
                  );
                  return {
                    value: formatedDate,
                    label: formatedDate,
                  };
                })
              );
            } else console.error(message);
          },
          error => {
            toast.error('Erro interno, por favor tente novamente mais tarde.');
            console.error(error);
          }
        )
        .then(() => {
          setLoader(false);
        });
    }

    GetStatementDates();
    setLoader(false);
  }, [property, props]);

  function handleConsultClick() {
    if (selectedDate === '') {
      toast.error('É obrigatório selecionar um vencimento antes de consultar.');
      return;
    }

    api
      .get(
        `api/v1/WSExtrato?Negocio=${property.businessId}&vencimentoData=${selectedDate}`
      )
      .then(
        response => {
          const {
            sucesso: success,
            mensagem: message,
            conteudo: sStatement,
          } = response.data;

          setStatement(sStatement);

          if (!success) toast.error(message);
        },
        error => {
          toast.error('Erro interno, por favor tente novamente mais tarde.');
          console.error(error);
        }
      )
      .then(() => {
        setLoader(false);
      });
  }

  function printStatement() {
    const input = document.getElementById('content_container');
    window.scrollTo(0, 0);
    var conf = { scale: 0.66 }
    if (isMobile) {}
    html2canvas(input, conf)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        var doc = new jsPDF("p", "mm", "a4");
        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();
        doc.addImage(imgData, 'PNG', 0, 0, width, height);
        doc.save("download.pdf");
      })
    return true;
  }

  function openInNewTab(href) {
    Object.assign(document.createElement('a'), {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: href,
    }).click();
  }

  function printStatement2(property) {
    let content = document.getElementById('main-extract-table').innerHTML;
    let style = `#main-extract-table{width:100%;margin-top:50px}#main-extract-table *{font-family:"Saira",sans-serif}#main-extract-table .extract-table-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:10px}#main-extract-table .extract-table-header h1{font-size:20px}#main-extract-table .extract-table-header .franquia-info{font-size:12px;display:flex;flex-direction:column}#main-extract-table .extract-table{width:100%;margin-bottom:10px}#main-extract-table .extract-table .table-title{background:#f7c325;text-align:center;font-weight:700}#main-extract-table .extract-table table{width:100%}#main-extract-table .extract-table table label{font-weight:700}#main-extract-table .extract-table table td{background:rgba(0,0,0,.05);padding:5px}#main-extract-table .extract-table table span.debit{color:#e74c3c}#main-extract-table .extract-table table span.credit{color:#27ae60}#main-extract-table .extract-table table tfoot tr td,#main-extract-table .extract-table table tfoot tr th,#main-extract-table .extract-table table thead tr td,#main-extract-table .extract-table table thead tr th{background:rgba(0,0,0,.09);font-weight:700;padding:5px}#main-extract-table .extract-table table tfoot tr td,#main-extract-table .extract-table table tfoot tr th{text-align:left}#main-extract-table .extract-table table td.bg-blue{background:#34495e}#main-extract-table .extract-table table td.bg-blue label{color:#fff}#main-extract-table .extract-table table .algLeft{text-align:right}`
    content = `<div id="main-extract-table">${content}</div>`
    let payload = {
      "html": JSON.stringify(content),
      "css": JSON.stringify(style),
      "head": JSON.stringify(`<link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Saira:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">`)
    }
    setLoader(true);
    axios.post("https://uiyek91vqe.execute-api.us-east-1.amazonaws.com/prod/html2pdf", payload)
      .then((response) => {
        setLoader(false);
        if (response.data.success) {
          openInNewTab(response.data.url)
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err)
      })
  }

  function naiveRound(num, decimalPlaces = 0) {
    var p = Math.pow(10, decimalPlaces);
    return Math.round(num * p) / p;
  }

  function checkDebitCredit(value) {
    if (value < 0) {
      return 'debit'
    }
    return 'credit'
  }

  useEffect(() => {
    if (statement.tipo10) {
      setFinancialResume(statement.tipo10.filter(el => el.idTipo < 20));
      setAnotherStatements(statement.tipo10.filter(el => el.idTipo > 20 && el.idTipo < 30));
      setStatementBalance(statement.tipo10.filter(el => el.idTipo > 30 && el.idTipo < 40));
    }

    if (statement.tipo50) {
      setPropertyStatements(statement.tipo50);
    }

    if (statement.tipo42) {
      let _depositData = []
      let _totalCredit = 0
      ;(statement.tipo42 || []).forEach((item = {}) => {
        const s = String(item?.banco ?? '');
        const parts = s.split('/');
        const bank = parts[0] ?? '';
        const rest = (parts[1] ?? '').trim();
        const arr = rest ? rest.split(/\s+/) : [];
        const agency = arr[0] ?? '';
        const accNumber = arr.length ? arr[arr.length - 1] : '';
        item.bank = bank;
        item.agency = agency;
        item.accNumber = accNumber;
        _totalCredit += Number(item?.valor ?? 0);
        _depositData.push(item);
      });
      setTotalCredit(_totalCredit);
      setDepositData(_depositData);
    }

    if (Object.keys(statement).length > 0) {
      let propertyItens = []
      if (statement.tipo50) {
        let year = selectedDate.split('/')[2]
        propertyItens = statement.tipo50.map((i, index) => ({
          key: `tipo50-${i.idTipo}-${index}`,
          _data: i.data ? `${year}-${i.data.split('/').reverse().join('-')}` : null,
          idTipo: i.idTipo,
          data: i.data,
          descricao: i.descricao,
          credito: i.credito,
          debito: i.debito,
        }))
      }

      if (statement.tipo10) {
        statement.tipo10.forEach((i, index) => {
          if ((!i.descricao.includes('BANCARIA') && i.idTipo == 22) || i.descricao.trim() == 'SALDO ANTERIOR') {
            let year = selectedDate.split('/')[2]
            let aluguelData = {
              key: `tipo10-${i.idTipo}-${index}`,
              _data: i.data ? `${year}-${i.data.split('/').reverse().join('-')}` : null,
              idTipo: i.idTipo,
              data: i.data,
              descricao: i.descricao,
              credito: i.credito,
              debito: i.debito,
            }
            propertyItens.push(aluguelData)
          }
        })
      }

      let total = 0
      let propertyItensSegmented = []
      var property = {}
      propertyItens.forEach((i, idx) => {
        let nextOne = typeof propertyItens[idx + 1] != 'undefined' ? propertyItens[idx + 1] : {}
        let nextTwo = typeof propertyItens[idx + 2] != 'undefined' ? propertyItens[idx + 2] : {}
        if (i.idTipo == 51) {
          let inquilino = nextOne.idTipo == 52 ? nextOne.descricao : ''
          let contrato_str = nextTwo.idTipo == 53 ? nextTwo.data : null
          contrato_str = !contrato_str && nextOne.idTipo == 53 ? nextOne.data : contrato_str
          let contract_split = contrato_str ? contrato_str.split(':') : null
          let contrato_num = contract_split && contract_split[1].replace(/\D/g, '')
          let contrato_reajuste = contract_split && contract_split[2].replace(/[^\d\/]/g, '')
          let imovel_parts = i.descricao.split('-')
          property = {
            imovel: i.descricao,
            referencia: imovel_parts[imovel_parts.length - 1],
            inquilino,
            contrato: contrato_num,
            contrato_reajuste,
            lancamentos: []
          }
        }
        if (typeof property != 'undefined' && (i.idTipo == 55 || i.idTipo == 22 || i.idTipo == 32)) {
          i._data = new Date(i._data)
          if (!property['lancamentos']) {
            property['lancamentos'] = [];
          }
          property['lancamentos'].push(i)
        }
        if ((nextOne && nextOne.idTipo == 51) || Object.keys(nextOne).length == 0) {
          property['subTotalCredit'] = naiveRound(property['lancamentos'].reduce(function (prev, obj) { return prev + obj.credito }, 0), 2)
          property['subTotalDebit'] = naiveRound(property['lancamentos'].reduce(function (prev, obj) { return prev + obj.debito }, 0), 2)
          property['total'] = naiveRound(property['subTotalCredit'] - property['subTotalDebit'], 2)
          total += property['total']
          propertyItensSegmented.push(property)
        }
      })

      setPropertyItensSegmented(propertyItensSegmented)

      let despesaBancaria = 0
      let saldoAnterior = 0
      if (statement.tipo10) {
        let despesaBancaria_filter = statement.tipo10.filter(i => i.descricao.trim() == 'DESPESA BANCARIA')
        if (despesaBancaria_filter.length > 0) {
          despesaBancaria = despesaBancaria_filter[0].total
        }
        let saldoAnterior_filter = statement.tipo10.filter(i => i.descricao.trim() == 'SALDO ANTERIOR')
        if (saldoAnterior_filter.length > 0) {
          saldoAnterior = saldoAnterior_filter[0].total
        }
      }
      setDespesaBancaria(despesaBancaria)
      setSaldoAnterior(saldoAnterior);
      total = naiveRound(total, 2)
      setTotal(total)
    }
  }, [statement]);

  return (
    <Container>
      <Loader style={{ display: loader ? 'block' : 'none' }} />

      <Info>
        <h3>Ref.: {property.reference}</h3>
        <h3>Nº do Negócio: {property.businessId}</h3>
        <h3 className="title">
          <p>Extrato</p> {property.address}
        </h3>
      </Info>

      <SelectContainer>
        <Select
          placeholder="Selecione o vencimento"
          noOptionsMessage={() => 'Nenhum vencimento encontrado'}
          options={dates}
          onChange={item => setSelectedDate(item.value)}
        />
        <button onClick={() => handleConsultClick()} type="button">
          Consultar
        </button>
      </SelectContainer>

      {statement && statement.tipo00 ? (
        <>
          <div id="main-extract-table">
            <div className="extract-table-header">
              <img src={logo} alt="Logo Apolar Imóveis" />
              <h1>PRESTAÇÃO DE CONTAS</h1>
              <div className="franquia-info">
                <span>{statement.tipo00.nomeFranquia}</span>
                <span> {statement.tipo00.enderecoEmpresa}, {statement.tipo00.bairro}, {statement.tipo00.cidade}-{statement.tipo00.estado} {statement.tipo00.cep}</span>
              </div>
            </div>

            <div className="extract-table">
              <div className="table-title">Dados do proprietário</div>
              <table>
                <tbody>
                  <tr>
                    <td><label>Proprietário:</label></td>
                    <td>{statement.tipo05.nomeProprietario}</td>
                    <td><label>Documento:</label></td>
                    <td>{statement.tipo05.documento}</td>
                    <td><label>Negócio:</label></td>
                    <td>{statement.tipo05.codigoNegocio}</td>
                  </tr>
                  <tr>
                    <td><label>Data do crédito:</label></td>
                    <td colSpan="2">{statement?.tipo42?.[0]?.data ?? '-'}</td>
                    <td colSpan="2"><label>Valor a creditar:</label></td>
                    <td> R$ {number_format(totalCredit)}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {propertyItensSegmented.map((obj, idx) => {
              return (
                <React.Fragment key={idx}>
                  <div className="extract-table" style={{ marginTop: '50px' }}>
                    <div className="table-title">Sobre o imóvel</div>
                    <table>
                      <tbody>
                        <tr>
                          <td><label>Imóvel:</label></td>
                          <td colSpan="2">{obj.imovel}</td>
                          <td><label>Inquilino:</label></td>
                          <td colSpan="2">{obj.inquilino}</td>
                        </tr>
                        <tr>
                          <td><label>Referência:</label></td>
                          <td>{obj.referencia}</td>
                          <td><label>Contrato:</label></td>
                          <td>{obj.contrato}</td>
                          <td><label>Próximo Reajuste:</label></td>
                          <td>{obj.contrato_reajuste}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="extract-table">
                    <div className="table-title">Detalhamento do imóvel</div>
                    <table>
                      <thead>
                        <tr>
                          <th colSpan="2">Descrição</th>
                          <th><span className="debit">Débito (-)</span></th>
                          <th><span className="credit">Crédito (+)</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {obj.lancamentos.map((lan, i2) => {
                          return (
                            <tr key={i2}>
                              <td>{lan.data}</td>
                              <td>{lan.descricao}</td>
                              <td><span className="debit">- R$ {number_format(lan.debito)}</span></td>
                              <td><span className="credit">R$ {number_format(lan.credito)}</span></td>
                            </tr>
                          )
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan="2">Sub-Total</th>
                          <th><span className="debit">- R$ {number_format(obj.subTotalDebit)}</span></th>
                          <th><span className="credit">R$ {number_format(obj.subTotalCredit)}</span></th>
                        </tr>
                        <tr>
                          <th colSpan="2" className="algLeft"><span className={checkDebitCredit(obj.total)}>R$ {number_format(obj.total)}</span></th>
                          <th colSpan="2"></th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </React.Fragment>
              )
            })}

            <div className="extract-table" style={{ marginTop: '50px' }}>
              <div className="table-title">SOMA DO TOTAL A CREDITAR</div>
              <table style={{ width: '50%', float: 'right', marginBottom: '20px' }}>
                <tbody>
                  <tr>
                    <td><label>Total</label></td>
                    <td>R$ {number_format(total)}</td>
                  </tr>
                  <tr>
                    <td><label>Despesa Bancária</label></td>
                    <td>{despesaBancaria < 0 ? '-' : ''} R$ {number_format(despesaBancaria < 0 ? despesaBancaria * -1 : despesaBancaria)}</td>
                  </tr>
                  <tr>
                    <td><label><span className="credit">Valor a creditar</span></label></td>
                    <td><label><span className="credit">R$ {number_format(totalCredit)}</span></label></td>
                  </tr>
                </tbody>
              </table>
              <div style={{ clear: 'both' }}></div>
            </div>

            {depositData.map((obj, idx) => {
              return (
                <React.Fragment key={`dep-${idx}`}>
                  <div className="extract-table">
                    <div className="table-title">Dados para depósito</div>
                    <table>
                      <tbody>
                        <tr>
                          <td className="bg-blue"><label>Nome:</label></td>
                          <td>{obj.favorecido}</td>
                          <td className="bg-blue"><label>CPF/CNPJ:</label></td>
                          <td>{obj.document}</td>
                          <td className="bg-blue"><label>Valor:</label></td>
                          <td>R$ {number_format(obj.valor)}</td>
                        </tr>
                        <tr>
                          <td className="bg-blue"><label>Banco:</label></td>
                          <td>{obj.bank}</td>
                          <td className="bg-blue"><label>Agência:</label></td>
                          <td>{obj.agency}</td>
                          <td className="bg-blue"><label>Conta:</label></td>
                          <td>{obj.accNumber}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </React.Fragment>
              )
            })}
          </div>

          <div style={{ textAlign: 'center', marginTop: '30px', marginBottom: '50px' }}>
            <button onClick={() => printStatement2(property)} type="button">IMPRIMIR</button>
          </div>
        </>
      ) : (
        ''
      )}
    </Container>
  );
}

export default Statement;
